import { useState } from "react"

export const VariableExpenses =() => {
    const [state, setState] = useState({
        search_value:"",
        description: "",
        invoice_number: "",
        invoice_image: "",
        delivery_receipt_image: "",
        expense_statement_id: "",
        user_id:"",
        account_id: "",
        image_type: "",
        notes: "",
        date:"",
        amount: "",
        remaining_amount : "",
        statement_id: "",
        statement_name: "",
        startDate: "",
        endDate: "",
        revolving: false,
        revolving1: '',
        open: false,
        openEdit: false,
        openExport :false,
        arr1: [],
        Load: false,
        openDetails: false
    })
    const setStateCustom = (variableName, value) => {
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    const setLoad = (value) => {
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };
    const setOpen = (value) => {
        setState((prevState) => ({
            ...prevState,
            open: value,
        }));
    };
    const setOpenExport = (value) => {
        setState((prevState) => ({
            ...prevState,
            openExport: value,
        }));
    };
    const setOpenDetails = (value) => {
        setState((prevState) => ({
            ...prevState,
            openDetails: value,
        }));
    };
    const setopenEdit = (value) => {
        setState((prevState) => ({
            ...prevState,
            openEdit: value,
        }));
    };
    const handleEdit= (event, arr) => {
        event.preventDefault();
        setState((prevState) => ({
            ...prevState,
            arr1: arr,
            openEdit: true
        }));
    }
    const handleChangeDate = (range) => {
        const [startDatee, endDatee] = range;
        setState((prevState) => ({
            ...prevState,
            startDate: startDatee,
            endDate: endDatee
        }));
    };
  return {
    ...state,
    state,
    setState,
    handleEdit,
    setOpen,
    setopenEdit,
    setStateCustom,
    setLoad, handleChangeDate,setOpenDetails,setOpenExport
  }
}

